import { formatPhoneForHuman } from '@admin/utils/format_phone_for_human';

import { PhoneWithName } from './types';

export function getPhoneOptionLabel(phone: Pick<PhoneWithName, 'number' | 'name'>): string {
  const numberLabel = formatPhoneForHuman(phone.number as unknown as string);
  const nameLabel = phone.name || '';
  return nameLabel ? `${numberLabel} (${nameLabel})` : numberLabel;
}

export const getStatusLabel = (message: {
  consentBlocked?: boolean;
  twilioStatus?: string | null;
  iterableStatus?: string | null;
}): string => {
  return message.consentBlocked ? 'blocked' : message.twilioStatus || message.iterableStatus || '';
};

const STATUS_CLASS_MAP: Record<string, string> = {
  queued: 'label label-warning',
  sent: 'label label-warning',
  delivered: 'label label-success',
  failed: 'label label-danger',
  undelivered: 'label label-danger',
};

export const getStatusClass = (message: {
  consentBlocked?: boolean;
  twilioStatus?: string | null;
  iterableStatus?: string | null;
}) => {
  if (message.consentBlocked) return 'label label-danger';

  const status = message.twilioStatus || message.iterableStatus;
  return status ? STATUS_CLASS_MAP[status] || '' : '';
};
